import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  stages: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  stages: state => state.stages,

  getById: (state) => (id) => {
    return state.stages.find(stage => stage.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of stages.
   */
  getList ({ commit }, {project_id, payload}) {
    return http.get(`/project/`+project_id+`/stages/list`, {params: payload}).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the clients state.
  */
  [SET_LIST] (state, stages) {
    state.stages = stages
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
